// extracted by mini-css-extract-plugin
module.exports = {"circleIcon":"dynamicTick_circleIcon__2n-uj","selected":"dynamicTick_selected__xxLLH","bigSmall":"dynamicTick_bigSmall__1mVSs","tick":"dynamicTick_tick__1RKWL"};